// 承諾情報移管申請画面
export const LABELS = {
  APPLICATION_TARGET_SERVICE: "申請対象サービス",
  APPLICATION_MANUAL: "申請マニュアル",
  APPLICATION_FILE: "申請ファイル",
  FILE_PLACEHOLDER: "アップロード対象ファイル",
  FOR_TRANSFER_CONFIRMATION: "移管可否事前確認",
  FOR_TRANSFER: "承諾移管実施　　",
  NO: "No",
  ERROR_DETAIL: "エラー内容",
  ERROR_FILENAME: "エラーファイル名",
  ERROR_OCCURRED_PLACE: "エラー発生箇所",
  ERROR_TITLE: "エラー内容",
  ERROR_TEXT_LABEL: "まだファイルはアップロードされていません。",
  CAUTIONARY_NOTE: "※CPID移管切り戻しファイルはこちらから申請してください"
} as const;

export const CONFIGS = {
  FILE: "file",
  FILE_EXTENSION_CSV: ".csv",
  UPLOAD_TYPE: "uploadType",
  TRANSFER_PRE_CHECK_FILE: "transferTargetCreateRequestFile", 
  CONSENT_TRANSFER_FILE: "transferTargetRequestFile",
  SUCCESS: "success",
  SELECT_ITEM: "selectItem",
  SEPARATOR: "（",
} as const;

export const CONTENTS = {
  APPLICATION_TRANSFER_CONFIRMATION: "\r\n・移管可否事前確認用{0}",
  APPLICATION_TRANSFER_CONFIRMATION_FILE: "\r\nファイル名：",
  APPLICATION_TRANSFER: "\r\n・承諾移管実施用\r\nファイル名：{0}",
} as const;